export default "__VITE_ASSET__BRc7Ony0__"